import styled from 'styled-components'

export const Pagination = styled.ul`
    z-index: 0;

    .page-item {
        &:first-child {
            .page-link {
                padding-left: 0;
            }
        }
        &:last-child {
            .page-link {
                padding-right: 0;
            }
        }

        &.active {
            .page-link {
                color: ${props => props.theme.admin.colors.brand};
                text-decoration: underline;
            }
        }

        .page-link {
            background-color: transparent;
            border: none;
            padding: 0 0.3rem;
            &:active,
            &:focus {
                outline: none;
                box-shadow: none;
            }

            &.disabled {
                background-color: transparent;
                color: ${props => props.theme.admin.font.color};
            }
        }
    }
`
